import React from 'react'
import mobile from "../Image/mobile1.png"

function MobileApplication() {
  return (
    <div>
      <section >
        <img class="d-block w-100" src={mobile} alt="img" />
      </section>
      <div className="statistics-wrap bg-gradient5">
        <div className="container">
          <div className="row small t-ctr mt0">
            <div className="col-lg-3 col-sm-6">
              <div className="statistics">
                <div className="statistics-img">
                  <img
                    src="images/icons/deal.svg"
                    alt="happy"
                    className="img-fluid"
                  />
                </div>
                <div className="statnumb">
                  <span className="counter">450</span>
                  <p>Happy Clients</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="statistics">
                <div className="statistics-img">
                  <img
                    src="images/icons/computers.svg"
                    alt="project"
                    className="img-fluid"
                  />
                </div>
                <div className="statnumb counter-number">
                  <span className="counter">400</span>
                  <span>+</span>
                  <p>Projects Done</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="statistics">
                <div className="statistics-img">
                  <img
                    src="images/icons/worker.svg"
                    alt="work"
                    className="img-fluid"
                  />
                </div>
                <div className="statnumb">
                  <span className="counter">95</span>
                  <span>k</span>
                  <p>Hours Worked</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="statistics mb0">
                <div className="statistics-img">
                  <img
                    src="images/icons/customer-service.svg"
                    alt="support"
                    className="img-fluid"
                  />
                </div>
                <div className="statnumb">
                  <span className="counter">24</span>
                  <span>/</span>
                  <span className="counter">7</span>
                  <p>Support Available</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*End Hero*/}
      {/*Start About*/}
      <section className="service pad-tb bg-gradient5">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="image-block wow fadeIn">
                <img
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRBtKzCHWzhUL7Pnbb7zF1F9n9ReYz4jow3GA&usqp=CAU"
                  alt="image"
                  className="img-fluid no-shadow"
                />
              </div>
            </div>
            <div className="col-lg-8 block-1">
              <div className="common-heading text-l pl25">
                <h2>Custom Mobile App Solutions</h2>
                <p style={{ textAlign: "justify" }}>
                  At N D Techland, we understand that mobile applications are more than just digital tools—they are extensions of your brand and key touchpoints for interacting with your customers. That's why we take a holistic and customer-centric approach to mobile application development. From conceptualization to deployment and beyond, our team of experienced developers, designers, and strategists collaborates closely with you to bring your vision to life and create mobile experiences that resonate with your audience.{" "}
                </p>
                <p style={{ textAlign: "justify" }}>
                  your trusted partner for innovative and user-centric mobile application solutions. Our mobile application services are designed to help businesses of all sizes leverage the power of mobile technology to reach, engage, and delight their target audiences.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*End About*/}
      <section className="service dark-bg4 pad-tb">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div className="text-l service-desc- pr25">
                <h3>Get a complete strategy of mobile app development</h3>
                <h5 className="mt10 mb20">
                  Hire Expert Cross Platform Mobile App Developers to Boost Your
                  Business
                </h5>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting
                  industry. Lorem Ipsum has been the industry's standard dummy text
                  ever since the 1500s, when an unknown printer took a galley of
                  type and scrambled it to make a type specimen book. Lorem Ipsum is
                  simply dummy text of the printing and typesetting industry.
                </p>
                <ul className="service-point-2 mt20">
                  <li> 100+ Mobile Delivered</li>
                  <li> 50+ Team Strength</li>
                  <li> User-Friendly Interface</li>
                  <li> 400 Happy Clients</li>
                  <li> 95% Repeat business</li>
                </ul>
                <a href="#" className="btn-main bg-btn2 lnk mt30">
                  Request A Quote <i className="fas fa-chevron-right fa-icon" />
                  <span className="circle" />
                </a>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="servie-key-points">
                <h4>Advantages of Mobile App Development</h4>
                <ul className="key-points mt20">
                  <li>Substitution of Traditional Method of Market</li>
                  <li>An effective way of Branding and engaging the audience</li>
                  <li>Reduction in cost and raises standards</li>
                  <li>Increase in Revenue</li>
                  <li>Gives more value to customers</li>
                  <li>24*7 support facility</li>
                  <li>Feasible and Convenient</li>
                  <li>Secured from vulnerable attacks</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="service-block bg-gradient6 pad-tb">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="common-heading ptag">
                <span>Service</span>
                <h2>Our Services</h2>
                <p className="mb30">
                  We think big and have hands in all leading technology platforms to
                  provide you wide array of services.
                </p>
              </div>
            </div>
          </div>
          <div className="row upset link-hover">
            <div
              className="col-lg-6 col-sm-6 mt30  wow fadeInUp"
              data-wow-delay=".2s"
            >
              <div className="s-block wide-sblock">
                <div className="s-card-icon-large">
                  <img
                    src="data:image/png;base64,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"
                    alt="service"
                    className="img-fluid"
                  />
                </div>
                <div className="s-block-content-large">
                  <h4>iOS App Development</h4>
                  <p style={{ textAlign: "justify" }}>
                    Whether you need a native iOS app for Apple devices, an Android app for Google Play Store, or a cross-platform solution that works seamlessly across multiple platforms, we have the expertise and experience to develop mobile applications that are tailored to your specific needs and objectives.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-sm-6 mt30 wow fadeInUp" data-wow-delay=".4s">
              <div className="s-block wide-sblock">
                <div className="s-card-icon-large">
                  <img
                    src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoHCBEREBEREREREhESEREPEQ8REhERDxEQGBQZGhgYGBgcIS4lHB4uIRgYJjgmKy8xNTU1GiQ7QDszPy40NT8BDAwMEA8QHxISHz8hIyQ0MTExMTQxPzExMTQxND80NTE1NDQ/NDU2NDE0NDQ2NDU0NDExNDE0NDExNDExNDE0NP/AABEIAOEA4QMBIgACEQEDEQH/xAAbAAEBAAIDAQAAAAAAAAAAAAAABgQFAQMHAv/EAEQQAAIBAQIHCgsGBgMAAAAAAAABAgMEEQUGEiExsbIWNEFRYXFykaHRFBUiMjNSU2JzgcETQoOS0uEjgpOjwvAkovH/xAAZAQEAAwEBAAAAAAAAAAAAAAAAAQIFBAP/xAA0EQEAAQMBAgsGBwEAAAAAAAAAAQIDEQQSIQUUMTNBcYGhweHwEzJCUWGxFSRSYnKR0SL/2gAMAwEAAhEDEQA/APZgAAAPipUjFXydyA+waythP1VcvWl3GurYW46j5lf9Dnr1VunpRlSAlPGy9afb3jxuvWn1vvPLj1r1JlVglPG69afW+8eN160+t944/a9SZVYJTxuvWn1vvHjdetPrfeOP2vUmVWCU8br1p9b7x43XrT633jj9r1JlVglPG69afW+8eN160+t944/a9SZVYJTxuvWn1vvHjdetPrfeOP2vUmVWCU8br1p9b7x43XrT7e8cftepMqsEp43XrT7e8eNl60+3vHH7XqTKrBLRwhF6Kk4vnnEyYWyss8Zqa9WaTv8A5kelGqt1GVADVWfC8W1GpF05PRfni+ZmzjJNXp3o6ImJ3wl9AAkAAAAOutUUIuT0JDkHVarSqa45PRH/AHgJ234Qzu95U+L7sT4wlbm28/lS/wCqNUYuq1c1Ts0+vNWZfdWtKfnP5cHUfABnzMzOZQAAgAAAAAAAAAAAAAAAAAAAPqnUlF3xbWo+QSNjStUaiyKiWfqb+jMizW2dmkoyblSbujJ6Y8kjTGbZqynF05501cr+FcR3aXV1U1Yq9eaYlY0Kymk0dpKYItcqVR0pu9LPBvhi9BUxler0bcTExmFn0ACQNPhu0ZKUeBK+X0NwSWHqt85Ljk18o5jk1lzYtT9US1UpuTbelu84AMBUABAAAAAAACuvV+i9X8dxlYUoRpzhk+jqRy6Unn4PKjfxr6l4omaZqjoxntGKACgAAADKwdZPtaii80F5U5aLorTnMCVrpzqTjC9QU5ZF7vyo8B6ezq2Nvo5PX0gdoAPMAAAAAAJ3AAZVrnlQhVXnQklLovT9GVGCLRlwXMStnWVGcPWg187v/DZYr174pG9obk129/QtCpBwcnakInC7/ivne0y2IjC3ppc8tpmdwlzcdaJYYAMVUAAAAAAAANhZqDtNnqWb70P4tCfBGXFfwX/VnOCcFSrvKlfGmnnfDJ8S7ysoWeFOKjCKjFcC+vGaWi01dU7c7qZzHXH+fVMQm7Bi5UcV9vOKlwqKyn82815soYv0FpUny33ajbg0KdHYp+HPXv8AunDUyxfs70KS5pX6zCtGLb006n8sl9V3FGBVo7FXwx2bvsYReGcqyWTIu/i2huM5rQqa+7fxv6skE7s6PX61GM4uM4qUWrnGSTTITGTFt0L6tG+VK++UdMqffHUcuo01VERNPJEf166SYYFjtWX5MvO2jMJ5O7Oja2O15fky87a/czK6Mb4VZgAPIAAAAAHdY35a5muwy8V5a3rMOy+cvnqMvFfh6T1mvwZ7tXYmlX5QPkGos7iHwt6WXPLaZcEPhT0sulLaZncJc3T1oliAAxVQAAAAAMjB9ldapGC0PPJ8SWlmOUuLFnuhKpwylkror932HRprXtbsUzycs9XrcQ3VKnGEVGKujFXJchOYy1qinGKcowuvVzuTlfnKY+KlOMldKKkuJpNdpuX7PtLexE4Xlr8A1ZyoJzvd0mot6XH68JszhJJXLMuQ5PS3RsUxTM5x0gYeFJzjQm4X5SWa7Slfna+V5mAmqNqmYzjIkcA2io68YqUpRlflpttXXaSslFNNNXpq5p6Gj5hSjG/JilfpuSV52HjprM2aNmZyPM8ZMFeC12op/Z1PLg+Ljj8tTRqE7s/CeiY42RVLLKX3qUlNP3dEl1O/5HnZnam17O5iOSd8Ky2tjteX5MvO2v3Mwnk7tBtbHasvyZedtHFXRjfCGYADyAAAdtm89fPUZOK3D0ntGLZ/PXz1GViq9PSe0a/BnJV2JpV4OAaizvIbCnpZdJ7TLkhsJ+llzvaZm8Je5T1oligAxlQAAAd9iszq1IwWbKed8UVnbLGhYKVON0YR5W0pSfO2den0lV+JmJxEJwhzfYOw3ZaFGFOpNxksptZE3pk+FI+sYMHQjTdaEVHJuc0vNcdF93BccYNwNZq9nhOpTy28rOpTjok7rrmdFizes3pppxnHTnGP9MTlk7qbF7V/kqdw3UWL2r/JU7jjcpYfYv8Aq1v1DcrYfYv+rW/Ud35n9vene53U2L2r/JU7hupsXtX+Sp3HG5Sw+xf9Wt+oblLD7F/1a36h+Z/b3m9zupsXtX+Sp3DdTYvav8lTuONylh9j/drfqG5Sw+x/u1v1D8z+3vN7ndTYvav8lTuG6mxe1f5KnccblLD7H+7W/UNyth9j/drfqH5n9veb2PhHGKyToVYKo3KdOcYrInnk4u7g4zz8v8I4t2OFCrONFqUKc5xf2lV3SUW1mcjU4o4DhWi69aOVFSyYQfmtrS3xrkOa9bu3K6aasZ+niSlgndoPV62DaE45EqNNxuuuyUuprOjzzGHBfgtdwi24SSnBvTkt3XPma1Hle01VqNrOYRhzY7Xl+TLztr9zMJ5O7ObWx2vL8mXnbX7nDXRjfCGYADyH3Z/PXz1GTip/k9oxqHnL56jJxU/ye0a/BnxdiaViADUWdxDYS9LPnetlyQuEfSz6T1szeE/cp60SxgAYyoAANpi5vhdGWoriRxd3wujLUV5u8Hcz2ytDXYf3paPhT1GNilvGl/PtsycP7ztHwZ6jFxT3jS/E25HRPPR/HxOlujk4OT2SHAOQOAAAAAGJhfe1f4NTZZrcTN40+lU22bLC+9q/wamyzW4mbxp9Kpts8J56P4z94OlvSHx+9LQ6EtouCHx+9LQ+HPWV1fMz2fdEpQJ3aNIBjqtrY7Xl+TLztr9zMJ5O42tjteX5MvO2v3PKujG+BnUvOXz1GTin/k9oxqXnI78U3tPaNHgz4uzxTStAAaqzuIXCHpZ9KWtl0Qlv9LPpS2mZvCfuU9aJY4AMZUAAG0xc3wujLUVxI4ub4XRlqK43eDuZ7ZWhr8P7ztHwZ6jGxT3jS/E25GTh/edo+DPUYuKO8aX4m3I9556P4z94OlugAe6QAAcgAAAcAYmF97V/g1NlmtxM3jT6VTbZssL72r/BqbLNbiZvGn06m2zwnno/jP3g6W9IfH70tD4c9ZckNj96Wh8Oesrq+Zns+6JSgAMdUCdwAG3wfastqMvO2s2s2WKP+T2iaou6SKTE/wCr1nfwfTja7PFaFsADSS7iEt/pZ9KW0y7IO3elqdOWtmbwn7lPWiXQADGVAABs8XX/AMiPLGWoryAo1ZQlGUXdKLvRQLGihFL7VThLki5xb5Gvqa2g1FFNGxVOJ5UwzcYGlY7Rf7KS+bVyOjFLeVL+fbkTGMeMfhMfsqScad6cpSzSndoV3AinxS3lS/n22dVFymu//wA9EeKeluQAdaQAAcgAAAAMLC+9q/wamyzW4mSXgVPklUT5Hlt/U2WF97V/g1NlkFi7h12VyjKLlSk03FedF8a7jku3Kbd2mavlMd8InlelELj9Jfa0VwqnJ3c8v2NvVxvsqjfHLlLghkOOflbzERhO3ytFWVWeZu5KK0RitCR56q/RNGzTOcksUAGaqAAD6p6UUmJ31esm4aSjxNet6zR0HxdnitC5ABoJdxBW30tTpy1svSCtnpanTltMzeE/cp60S6QAYyoAAB8VKakmpK9M+wSNJarM6b44vRIvMTLTGdlUE/KpylGS4bm20+3sJycFJNNXpmvp1KtlqZdKbjwKWlNcUloZ2aXUezrzKYl6oCCjjnaLs9Ok3x3SX1LHBVplWs9KrJJSnBSaWhPkNi3fouTilZmAEvjDjFVstf7OEKco5EZXyyr723xPkL3LlNuNqoVAI/A+NNavaKdKUKajOTTccq9XRbzZ+QsCLd2m5GaRyDqrzyYSa0xjKXzSvIfdraPZ0uqfeRcvUW8bXSKjGO0xp2Ss5PPKDpxXC5SV1yPMDMwlhOtaZKVWd93mxSyYR5l9TDMvUXva1ZjkhUABzoAAAAAHK0lHia9b1k2ijxM0Lnes0dD8XZ4rQuwcA0Eu8gbZ6Wp05a2XxAWt/wAWr8SWtmbwn7lPWiXWADGVAAAAAA+ZwUk01emfQA0tqszg+OL0P6M9Jxc3nQ6H1ZHTipJpq9PgLXAUFGy0YrQo3drNTg6vNVWfl4phnnnuO+/PwYbTPQjzzHd/8z8KGuR26zmu2Eyw8WN/WfpS2JHp55hixv2z9OWzI9QKaH3J6/CCHRa/R1OhLUzyFHr1s9FU+HPUzyFHlr+WntJcgA4FQAAAAAAAAo8TNHzesm2UeJf1es0dB8XZ4rQuwAaCXeefWrNXrR4qk12s9BILGGn9nbJ8VRKrHlzXS+nWcWvo2rWflOUS6QcJnJgqgAAAAAAABu8C4YhTh9nVbUU24zubSTd7TuNID1s3qrVW1SKu1YxWSnFy+2hN3ZoQeVJ8mbR8zz3CdulaK06sszk80dKjFZkjuttj0zguVx+qNeddzU1Xo+UJdlnrypzjOLulGSlF8qZ6Jg/GWzVYpyqRpSu8qM3ck+STzNHm4Js36rXJ0i1xixlpulKjQllymnGVRX5MYtZ7nwvgIoArdu1XKs1AADyQAAAAABwcgD4qyuXaU+JkLkuvUSVaWU1Ffed3y4S/xWs2TBZuL/e01dFRiiZ+fgtCmuB33A7EuScxwsDqUo1Yq+dJ33ccXpRRnxOKknF501cyJiJjEjzOy2hNLPmejkfEZh14w4KlZqkqkE3Sk75RX3XxoxLNbFcr3fHgkjA1Omm1V9J9f2rMM8HzGSavTvR9HIgAAAAAAAANfbbHpnBcritaNgC0TMcgngbK22S/y4LPwx4+VGtPemqJ5AABIAAAAAABw3cBydVWpdm6z4qWjgj1nxZqEqsklfk8L4z3s2KrlSWZgayOpUUrsyzJHp+CLNkRXIv9+pocX8F5CTu/3jK+lDJVxs00xTERHQs+wASAAAx7XZo1IuMleQeGMW50pSnRzcLjpi/keiHxUgpK5q8iqIqjE7x5D4TODunGVN8avyTJp4Sb0OMtZfW7AVOpf5KJ+1YnwbzRu+RxV6C3Vybu/wA+9GGm8YP1V1nPjD3e0zHihz9cjjchz9cjx/DY/V3eZhieH+72jw/3e0y9yHP1yG5Dn65D8Mj9Xd5o2WJ4w93tHjD3e0y9yHP1yG5Dn65D8Mj9Xd5myxPD/d7R4w93tMvchz9chuQ5+uQ/DI/V3eZssTxh7q6zBtlTK8qMFfwq/T+5udyHP1yG5Dn65Exwdjkq7vNOEv4X7vaPC/d7Sn3Hrif/AGG45cT7T04jHz7vMwmPC/d7R4X7vaU+45cT7RuOXE+0cRj593mYTHhfu9px4X7vaVG45cT7RuOXE+0cRj593mYSsrXLkR15UpvNfLUWdPFFJ6NfcbKyYtQjdm7P/T0o0dEcs57jCKsOCJ1GspXLiXD3lpgfAahdeuLN39xvbLgqMOBI2NOmo6Os6qaYpjEbkuuz2dQXKZABIAAAAAAAAHDAA6ZnyAAAAAAAAAAAAHIAAAAAAAETvQAHIAAAAAAAP//Z"
                    alt="service"
                    className="img-fluid"
                  />
                </div>
                <div className="s-block-content-large">
                  <h4>Android App Development</h4>
                  <p style={{ textAlign: "justify" }}>
                    We specialize in developing custom mobile applications that are designed to address your unique business requirements and deliver value to your customers. Whether you need a consumer-facing app, an enterprise solution, or a productivity tool, our team has the skills and capabilities to bring your ideas to life.

                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-sm-6 mt30 wow fadeInUp" data-wow-delay=".4s">
              <div className="s-block wide-sblock">
                <div className="s-card-icon-large">
                  <img
                    src="https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcR_EJPBavDL1lm45DKKlBG7AiU-k5FmHvqo7o4dS-HAABc6qXNy"
                    alt="service"
                    className="img-fluid"
                  />
                </div>
                <div className="s-block-content-large">
                  <h4>Hybrid App Development</h4>
                  <p style={{ textAlign: "justify" }}>
                    We understand the importance of intuitive and engaging design in driving user adoption and retention. Our UX designers leverage industry best practices and user-centered design principles to create mobile interfaces that are not only visually appealing but also easy to use and navigate.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-sm-6 mt30 wow fadeInUp" data-wow-delay=".8s">
              <div className="s-block wide-sblock">
                <div className="s-card-icon-large">
                  <img
                    src="https://www.ivaninfotech.com/images/crm/crm-img3.png"
                    alt="service"
                    className="img-fluid"
                  />
                </div>
                <div className="s-block-content-large">
                  <h4>CRM App Development</h4>
                  <p style={{ textAlign: "justify" }}>
                    We specialize in integrating third-party services, APIs, and backend systems to extend the functionality of your mobile application and enhance its capabilities. Whether it's integrating with payment gateways, social media platforms, or external databases, we ensure seamless integration and interoperability with your existing infrastructure
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="-cta-btn mt70">
            <div
              className="free-cta-title v-center wow zoomInDown"
              data-wow-delay="1.1s"
            >
              <p>
                Hire a <span>Dedicated Developer</span>
              </p>
              <a href="#" className="btn-main bg-btn2 lnk">
                Hire Now
                <i className="fas fa-chevron-right fa-icon" />
                <span className="circle" />
              </a>
            </div>
          </div>
        </div>
      </section>




    </div>
  )
}

export default MobileApplication